import { render, staticRenderFns } from "./LogsRequisicoes.vue?vue&type=template&id=41cefd77"
import script from "./LogsRequisicoes.vue?vue&type=script&lang=js"
export * from "./LogsRequisicoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports